import { render, staticRenderFns } from "./AdminOrganizationDetail.vue?vue&type=template&id=1cba57a4&scoped=true"
import script from "./AdminOrganizationDetail.vue?vue&type=script&lang=js"
export * from "./AdminOrganizationDetail.vue?vue&type=script&lang=js"
import style0 from "./AdminOrganizationDetail.vue?vue&type=style&index=0&id=1cba57a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cba57a4",
  null
  
)

export default component.exports